module.exports = __webpack_public_path__ + "static/media/Github.a5b60587.png";